import { render } from "./FinishCertTH.vue?vue&type=template&id=609966de&scoped=true"
import script from "./FinishCertTH.vue?vue&type=script&lang=js"
export * from "./FinishCertTH.vue?vue&type=script&lang=js"

import "./FinishCertTH.vue?vue&type=style&index=0&id=609966de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609966de"]])

export default __exports__